import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/layout'

import menuList from "@/views/sys/menu.vue";
import role from "@/views/sys/RoleManagement.vue";
import resource from "@/views/sys/resource.vue";
import sysUser from "@/views/sys/PeopleManagement.vue";

import {
  vuexOidcCreateRouterMiddleware
} from 'vuex-oidc' //oidc
import store from '@/store'

Vue.use(Router)


export const constantRoutes = [{
    path: '/',
    name: 'dashboard',
    component: Layout,
    redirect: 'dashboard',
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: Layout,
      hidden: true,
      isRedirct: true,
      component: () => import('@/views/dashboard/index.vue'),
      meta: {
        title: '首页',
        icon: 'el-icon-s-marketing',
        affix: true
      }
    }, {
      path: 'updatePwd', //oidc
      name: 'updatePwd',
      component: () => import('@/views/account/updatePwd.vue'),
      isRedirct: false,
      meta: {
        isPublic: false
      },
      hidden: true
    }]
  },
  {
    path: '/dicomviewer', //oidc
    component: () => import('@/views/study/dicomviewer.vue'),
    name: "dicomviewer",
    hidden: true,
  },
  {
    path: '/oidc-callback', //oidc
    component: () => import('@/views/Oidc/OidcCallback.vue'),
    name: "oidcCallback",
    hidden: true,
  },
  {
    path: '/oidc-callback-error', //oidc
    name: 'oidcCallbackError',
    component: () => import('@/views/Oidc/OidcCallbackError.vue'),
    meta: {
      isPublic: true
    },
    hidden: true
  },
  {
    path: '/oidc-silent-renew', //oidc
    name: 'oidcSilentRenew',
    component: () => import('@/views/Oidc/OidcSilentRenew.vue'),
    meta: {
      isPublic: true
    },
    hidden: true
  },// 强制刷新当前页所用的中间跳转页
  {
       path: '/redirect/:path*',
       component: () => import('@/views/redirect/index'),
       hidden: true
 }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  mode: 'history',
  routes: constantRoutes
})

const router = createRouter()

router.beforeEach(vuexOidcCreateRouterMiddleware(store)) //oidc

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js